import React, { useState } from "react";
import Style from "./index.module.scss";
import Header from "components/Header";
import { Breadcrumb, Button, Card, Icon } from "antd";
import { useParams } from "react-router-dom";
import NavBar from "./components/NavBar";

import RulesSetting from "./RulesSetting";
import CourseInfoHeader from "../Components/CourseInfoHeader";
import { useHistory, useLocation, useRouteMatch } from "react-router-dom";
import qs from "qs";
import { useAtomValue } from "jotai";
import { isProcessAtom } from "./store";
import { isTrue } from "../../../service/service";
import RulesPaper from "./RulesPaper";
import {
    getGradeOperator,
    NavState,
    queryDcGradeTypeSet,
    queryPublishStatus
} from "../../../service/score";
import useRequest from "../../../utils/useRequest";
import ScoreContext from "./context";
import Config from "../../../config";
import useBatchNo from "../../../utils/useBatchNo";

export default function PageScore() {
    const { url } = useRouteMatch();
    const location = useLocation();
    const history = useHistory();

    const { from } = qs.parse(location.search, {
        ignoreQueryPrefix: true
    });
    const { nav } = qs.parse(location.search, {
        ignoreQueryPrefix: true
    });

    const { courseNo, courseSeq } = useParams<StringMap>();
    const isProcess = useAtomValue(isProcessAtom);

    const [mark, setMark] = useState<number>(
        Number(nav || 0) || NavState.Rules
    ); //默认选中成绩规则

    //成绩单发布状态
    const [publishStatus, { loading }, refreshData] = useRequest(
        () => queryPublishStatus(courseNo, courseSeq),
        {},
        [courseNo, courseSeq]
    );

    const [Operator, { loading: OperatorLoading }, ReloadOperator] = useRequest(
        () => getGradeOperator(courseNo, courseSeq),
        {},
        [courseNo, courseSeq]
    );

    const { batchNo } = useBatchNo();
    const [ShowType, { loading: ShowTypeLoading }, ReloadShowType] = useRequest(
        () =>
            queryDcGradeTypeSet({
                batchNo,
                courseNo,
                courseSeq,
                customerCode: Config.CustomCode
            })
    );

    /**
     * 修改路由
     * @param nav
     */
    const onChangeNav = (nav: number) => {
        setMark(nav);
        history.replace(`${url}?nav=${nav}`);
    };

    return (
        <ScoreContext.Provider
            value={{
                Operator,
                ReloadOperator,
                OperatorLoading,
                ShowType,
                ShowTypeLoading,
                ReloadShowType
            }}>
            <div id="scroll1">
                <Header />

                <div className={Style.root}>
                    <Breadcrumb separator=">">
                        <Breadcrumb.Item href="/">首页</Breadcrumb.Item>
                        {from === "detail" && (
                            <Breadcrumb.Item>
                                <a onClick={() => history.goBack()}>课程内容</a>
                            </Breadcrumb.Item>
                        )}

                        <Breadcrumb.Item>
                            <a href="">成绩管理</a>
                        </Breadcrumb.Item>
                    </Breadcrumb>

                    <Card
                        title={
                            <CourseInfoHeader
                                courseNo={courseNo}
                                courseSeq={courseSeq}
                            />
                        }
                        bordered={false}
                        className={Style.container}
                        extra={
                            <Button
                                type="primary"
                                ghost
                                className={Style.btn}
                                onClick={() =>
                                    history.push(
                                        `/course/${courseNo}/${courseSeq}/analyse?nav=2`
                                    )
                                }>
                                <Icon type="fund" />
                                查看学情分析
                            </Button>
                        }>
                        {isTrue(isProcess) && (
                            <div className={Style.head}>
                                <div className={Style.subTitle}>过程化考核</div>
                            </div>
                        )}

                        <NavBar
                            mark={mark}
                            onChange={(val: number) => onChangeNav(val)}
                            courseNo={courseNo}
                            courseSeq={courseSeq}
                            status={publishStatus}
                            refreshData={refreshData}
                        />

                        <div className={Style.content}>
                            {mark === NavState.Rules && (
                                <RulesSetting
                                    courseNo={courseNo}
                                    courseSeq={courseSeq}
                                />
                            )}

                            {mark === NavState.Paper && (
                                <RulesPaper
                                    courseNo={courseNo}
                                    courseSeq={courseSeq}
                                    status={publishStatus}
                                    publishLoading={loading}
                                />
                            )}
                        </div>
                    </Card>
                </div>
            </div>
        </ScoreContext.Provider>
    );
}
